import React, { useState } from "react";
import { ErrorMessage, useField } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const TextField = ({ isDisabled, ...props }) => {
  const [field, meta] = useField(props);
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = props.type === "password";
  const inputType = isPassword
    ? showPassword
      ? "text"
      : "password"
    : props.type;

  const hasError = meta.touched && meta.error;

  return (
    <div style={{ margin: "0.4rem", fontSize: "0.8rem" }}>
      <div style={{ position: "relative" }}>
        <input
          className={`form-control shadow-none field-input ${
            hasError ? "is-invalid" : ""
          }`}
          autoComplete="off"
          {...field}
          {...props}
          type={inputType}
          disabled={isDisabled}
          
        />

        {isPassword && (
          <FontAwesomeIcon
            icon={showPassword ? faEyeSlash : faEye}
            onClick={() => setShowPassword((prev) => !prev)}
            style={{
              position: "absolute",
              right: "35px",
              top: "35%",
              cursor: "pointer",
              pointerEvents: "auto", // ensures it's clickable even if overlapping
            }}
          />
        )}
      </div>

      <ErrorMessage
        component="p"
        name={field.name}
        style={{
          fontSize: "11px",
          color: "red",
          textAlign: "left !important",
        }}
      />
    </div>
  );
};

export default TextField;
